import { Typography, styled } from "@mui/material";
import CollapsibleSection from "../../../components/collapsible-section/collapsible-section";
import { useAppSelector } from "../../../redux/store";
import { IWithClassName, IWithThemeProps } from "../../../theme/default.theme";

const AvailableFields = ({ className }: IWithClassName) => {
    const { details, isLoading } = useAppSelector(
        ({ listPage }) => listPage.listDetails,
    );

    return (
        <CollapsibleSection
            className={className}
            title="Available Data-Fields"
            collapsible={true}
            collapsed={true}
            isLoading={isLoading}
        >
            <Typography className="available-data-fields">
                {details?.headers?.join(", ")}
            </Typography>
        </CollapsibleSection>
    );
};

export default styled(AvailableFields)(({ theme }: IWithThemeProps) => ({
    paddingTop: theme?.spacing(3),
    marginBottom: theme?.spacing(4),
    fontSize: "20px",
    color: theme?.palette.announcement.primaryColor,
    ".available-data-fields": {
        padding: theme?.spacing(2),
    },
}));
